import React from 'react';

var SortBox = React.createClass({
  getInitialState: function(e){
        return {value : "Sort By"}
  },
  handleDropdownClick: function(e){
      e.stopPropagation();
      this.props.sortBoxShow();
  },
  handleSortClick: function(value){
      this.props.onSortChange(value);  // when clicks on any options of sorting, this will set the propery so that sorting of data will be display based upon this.
  },
  render: function(){
    var sorts = ["Name", "Rating", "Last Modified", "Date Purchased"];
    var result = sorts.map((value, index) => (
              <li onClick = {this.handleSortClick.bind(this,value)} key = {index}>
                <a href="javascript:void(0)">
                  <span className="value">{value}</span>
                </a>
              </li>
    ));
    return(
        <div className="filter-head__right">
            <div className="custom-dropdown custom-dropdown--default">
              <dl className="dropdown" >
                <dt onClick = {this.handleDropdownClick}>
                   <a href="javascript:void(0)" >
                     <span className="value">{this.props.sort}</span>
                   </a>
                </dt>
                <dd>
                  {this.props.sortBy ? 
                   <ul>
                    {result}
                    </ul> : <div />
                  }
                </dd> 
              </dl>
            </div>
        </div>
    );
  }
});

export {SortBox}


/** WEBPACK FOOTER **
 ** ./html/components/SortBox.jsx
 **/